// extracted by mini-css-extract-plugin
export var markdown = "_vf-0";
export var tableWrapper = "_vf-1";